import axios from 'axios';

export default {
    getAccessToken() {
        return axios.get(window.API_BASE + '/sumsub-access-token');
    }
}